const Projects = [
  { id: 0, text: "Latest Release", link: "/" },
  { id: 1, text: "Updates", link: "/" },
  { id: 2, text: "JavaScript API", link: "/" },
  { id: 3, text: "GraphQL API", link: "/" },
  { id: 4, text: "License", link: "/" },
  { id: 5, text: "GitHub Project", link: "/" },
  { id: 6, text: "Old Version 4.7", link: "/" },
];

const Support = [
  { id: 0, text: "Troubleshooting", link: "/" },
  { id: 1, text: "Common Questions", link: "/" },
  { id: 2, text: "Report a Bug", link: "/" },
  { id: 3, text: "Get Help", link: "/" },
];

const Company = [
  { id: 0, text: "Blog", link: "/" },
  { id: 1, text: "Status", link: "/" },
  { id: 2, text: "Contact Us", link: "/" },
];

const companyExperience = [
  { id: 0, text: "Gallery", link: "/" },
  { id: 1, text: "Cheatsheet", link: "/" },
  { id: 2, text: "Requests Leaderboard", link: "/" },
  { id: 3, text: "Request an Icon", link: "/" },
];

export { Projects, Support, Company, companyExperience };
